import React from 'react'
import { css } from '@emotion/core'
import { restaurantFieldHighlightStyle } from './restaurant-table-styles'

export type RestaurantCellLine = {
  value: string | number
  isHighlighted?: boolean
}

type Props = {
  lines: RestaurantCellLine[]
}

/**
 * 複数行の表示の必要があるセル
 *
 * ラッパーを display: contents にすることで、各行アイテムが親セル（subgrid）の
 * 行トラックに直接配置され、同じレコードを示す行の高さが列間で揃う。
 */
export const RestaurantCellLines: React.FC<Props> = ({ lines }) => {
  if (lines.length === 0) {
    return <div css={cellLineItemStyle}>-</div>
  }

  return (
    <div css={cellLinesStyle}>
      {lines.map(({ value, isHighlighted }, index) => (
        <div
          key={`${value}-${index}`}
          css={[cellLineItemStyle, index > 0 && cellLineDividerBorderStyle, isHighlighted && restaurantFieldHighlightStyle]}
        >
          {value}
        </div>
      ))}
    </div>
  )
}

const cellLinesStyle = css({
  display: 'contents',
})

const cellLineItemStyle = css({
  lineHeight: 1.5,
  minWidth: 0,
  padding: '10px 12px',
})

const cellLineDividerBorderStyle = css({
  borderTop: '2px solid #F2F2F2',
})
